import React from 'react';
import FacebookLogin from '@greatsumini/react-facebook-login';
import './styles.css'; 
import ApiService from '../../classes/ApiService';
import { toast } from 'react-toastify';

/* {
  "accessToken": "EAAGm0PX4ZCpsBA...", //accessToken: A token that can be used to make authenticated requests to the Facebook API.
  "userID": "1234567890", //userID: The unique identifier for the user.
  "expiresIn": 5183944, //expiresIn: The time in seconds until the access token expires
  "signedRequest": "abcd1234...", //signedRequest: A signed parameter that contains information about the user and the app.
  "name": "John Doe", //name: The user's full name.
  "email": "johndoe@example.com", //email: The user's email address (if requested).
  "picture": {
      "data": {
      "height": 50,
      "is_silhouette": false,
      "url": "https://platform-lookaside.fbsbx.com/platform/profilepic/?asid=1234567890&height=50&width=50&ext=...",//picture: The URL of the user's profile picture.
      "width": 50
      }
  }
  } */

  const ToastContent = ({ header, body }) => (
    <div>
      <strong style={{ fontSize: "16px" }}>{header}</strong>
      <p style={{ margin: "5px 0 0" }}>{body}</p>
    </div>
  );

  const FacebookLoginButton = ({ onSuccess, onError, text, redirectUri, type }) => {

    const handleFacebookLogin = async (credentialResponse) => {
      const apiService = new ApiService();
      const toastId = toast.loading('Signing in with Facebook...', { ariaLabel: "Signing in with Facebook"});
      console.log(credentialResponse)
      try {
        const response = await apiService.post('/registration/guest/facebook-login', { token: credentialResponse, type });
        localStorage.setItem('token', response.data.token);
        toast.update(toastId, {
          render: <ToastContent header="Facebook Login Successful" body="You have successfully logged in with Facebook." />,
          type: 'success',
          isLoading: false,
          autoClose: 5000
        });
        onSuccess(response);
      } catch (error) {
        toast.update(toastId, {
          render: <ToastContent header="Facebook Login Failed" body="There was an error logging in with Facebook." />,
          type: 'error',
          isLoading: false,
          autoClose: 5000
        });
        onError(error);
      }
    };
  
    return (
      <FacebookLogin
        appId={process.env.REACT_APP_FACEBOOK_APP_ID}
        onSuccess={handleFacebookLogin}
        fields="name,email,picture, user_birthday"
        onFail={(error) => {
          const toastId = toast.loading('Signing in with Facebook...', { ariaLabel: "Signing in with Facebook"});
          toast.update(toastId, {
            render: <ToastContent header="Facebook Login Failed" body="There was an error logging in with Facebook." />,
            type: 'error',
            isLoading: false,
            autoClose: 5000
          });
          if(onError){
            onError(error);
          }
        }}
        onProfileSuccess={(response) => {
          console.log('Get Profile Success!', response);
        }}
        render={({ onClick, logout }) => (
          <div onClick={() => onClick()} className='facebook-signin-btn' style={{ textAlign: 'center' }}>
            <img width="16px" height="16px" src="/img/facebook_icon.svg" alt="facebook" />
            <span>{text || "Continue with Facebook"}</span>
          </div>
        )}
      />
    );
  };
  
  export default FacebookLoginButton;